import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AmdocsEventBusService } from 'amdocs-core-package';
import { CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit,OnDestroy {
  isFrame:boolean=true;
  private router = inject(Router);
  private location = inject(Location);
  private eventBus = inject(AmdocsEventBusService);

  constructor() {
    // Retain any logic inside the constructor
  }

  ngOnInit(): void {
    this.eventBus.emit(CONSTANTS.EVENTS.IS_FIXED_FOOTER,true);
  }

  openHomePage(){
    this.router.navigate(['/']);
  }
  
  openPreviousPage(){
    this.location.back();
  }
  ngOnDestroy(): void {
    this.eventBus.emit(CONSTANTS.EVENTS.IS_FIXED_FOOTER,false);
  }

  checkIfInIframe(): void {
    if (window.self !== window.top) {
      console.log('Page is in an iframe');
      this.isFrame=true;
      // Execute specific logic for iframe
    } else {
      console.log('Page is not in an iframe');
      this.isFrame=false;
      // Execute specific logic for non-iframe
    }
  }
}
